<template>
    <router-link v-if="path" :to="path ? path : '/'"  v-bind:class="buttonClass">{{ buttonText }}</router-link>
    <a v-else v-bind:class="buttonClass">{{ buttonText }}</a>
</template>

<script>
    export default {
        props: ['buttonText', 'buttonClass', 'path', 'clickEvent']
    }
</script>

<style scoped>
    a {
        box-shadow: none;
        border: none;
        font-size: 17px;
        color: #FFF;
        float: right;
        padding: 10px 20px;
        cursor: pointer;
        position: relative;
    }

    a.blue {
        background: #026a9f;
    }

    a.white {
        background: #FFFFFF;
        color: #000000;
    }

    a.login {
        padding: 6px 15px 10px 37px;
    }

    a.login:before {
        content: '';
        position: absolute;
        background: url('../../assets/images/user.svg') no-repeat;
        width: 16px;
        height: 16px;
        left: 16px;
        top: 12px;
    }

    a.yellow {
        padding: 10px 20px;
        background: #fdd94d;
        color: #000;
        float: left;
        font-weight: 700;
    }

    a.big {
        padding: 14px 40px;
    }
    
    a.height {
        padding-top: 17px;
        padding-bottom: 17px;
    }
</style>


// WEBPACK FOOTER //
// src/views/elements/ButtonEl.vue